import {
  FailModalGrooveTicket,
  SendApiRequest,
  SuccessModalGrooveTicket,
  getTargetInbox,
  useTicketState,
} from "./utils"
import React, { useEffect } from "react"

export const CreateRecallGrooveTicket = ({ segment }) => {
  const {
    setState,
    ticketState,
    setTicketState,
    datenschutzToggle,
    updatePhoneNumber,
    updateCompanyName,
    updateCustomerName,
    updateRecallTime,
  } = useTicketState()

  const targetInbox = getTargetInbox(segment)

  const closeFailModal = () => setTicketState("failModalClass", "")
  const setButtonLoading = () => setTicketState("buttonLoading", true)
  const closeSuccessModal = () => setTicketState("successModalClass", "")

  const launchModal = (success) => {
    success
      ? setTicketState("successModalClass", "is-active")
      : setTicketState("failModalClass", "is-active")
  }

  const handleSubmit = () => {
    setButtonLoading()
    SendApiRequest({
      phoneNumber: ticketState.phoneNumber,
      companyName: ticketState.companyName,
      customerName: ticketState.customerName,
      recallTime: ticketState.recallTime,
      targetInbox: targetInbox,
      launchModal: launchModal,
    })
  }

  useEffect(() => {
    const current_time_utc = new Date()
    const current_time_cet = new Date(
      current_time_utc.getTime() - current_time_utc.getTimezoneOffset() * 60000
    )
      .toISOString()
      .substr(0, 16)
    setState({
      ...ticketState,
      recallTime: current_time_cet,
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="columns is-centered is-vcentered is-gapless">
        <div className="column is-half">
          <div className="control has-icons-right">
            <input
              className="input"
              type="text"
              placeholder="Name"
              onChange={updateCustomerName}
              onKeyDown={() => {}} //shhhh es lint
              aria-label="customer name recall ticket"
            />
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>

        <div className="column is-half">
          <div className="control has-icons-left">
            <input
              className="input"
              type="text"
              placeholder="Firmenname"
              onChange={updateCompanyName}
              onKeyDown={() => {}}
              aria-label="company-ticket"
            />
          </div>
        </div>
      </div>

      <div className="columns is-centered is-vcentered is-gapless">
        <div className="column is-half ">
          <div className="control has-icons-right">
            <input
              className="input"
              type="text"
              placeholder="Telefonnummer"
              onChange={updatePhoneNumber}
              onKeyDown={() => {}}
              aria-label="phone-ticket"
            />
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>

        <div className="column is-half ">
          <div className="control has-icons-right">
            <input
              className="input"
              type="datetime-local"
              value={ticketState.recallTime}
              onChange={updateRecallTime}
              onKeyDown={() => {}}
              aria-label="date-ticket"
            />
            <span className="icon is-medium is-right input-asterisk">*</span>
          </div>
        </div>
      </div>

      <p className="has-text-centered help">
        Die mit * (Stern) gekennzeichneten Felder müssen ausgefüllt werden.
      </p>

      <div className="columns is-centered is-vcentered is-gapless mb-2 signup-checkboxes">
        <div
          onClick={datenschutzToggle}
          onKeyPress={() => {}}
          role="button"
          tabIndex="-5"
          aria-label="Select Datenschutzbestimmungen"
          className="column"
        >
          <input
            type="checkbox"
            id="datenschutzCheckboxRecallTicket"
            name="datenschutzCheckboxRecallTicket"
            onChange={() => {}}
            checked={ticketState.checkboxDatenschutz}
          />
          <label htmlFor="datenschutzCheckboxRecallTicket">
            <span className="pl-3">
              Ich akzeptiere die Bestimmungen zum{" "}
              <a
                href={"/datenschutzerklaerung"}
                target="_blank"
                rel="noopener noreferrer"
                className="link"
              >
                Datenschutz
              </a>
              .
            </span>
          </label>
        </div>
        <div className="column is-3 has-text-right">
          <button
            className={`button is-mitternachtsblau ${
              ticketState.buttonLoading ? "is-loading" : ""
            }`}
            disabled={
              !ticketState.checkboxDatenschutz ||
              !ticketState.customerName ||
              !ticketState.phoneNumber
            }
            onClick={handleSubmit}
          >
            <b>Anfrage absenden</b>
          </button>
        </div>
      </div>
      <div className=" mb-2">
        <br />
        Wir versuchen, Sie zu Ihrer gewünschten Zeit zurückzurufen. Während
        besonders geschäftiger Zeiten kann es allerdings zu Verzögerungen
        kommen, die wir nachzusehen bitten.
      </div>

      <SuccessModalGrooveTicket
        {...{
          successModalClass: ticketState.successModalClass,
          setButtonLoading,
          closeSuccessModal,
          segment,
          targetInbox,
        }}
      />

      <FailModalGrooveTicket
        {...{
          failModalClass: ticketState.failModalClass,
          setButtonLoading,
          closeFailModal,
          segment,
          targetInbox,
        }}
      />
    </div>
  )
}
